import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {BaseService} from "../../services/base.service";
import {HttpClient} from "@angular/common/http";
import {Meta, Title} from "@angular/platform-browser";
import {Subject} from "rxjs";
import {finalize, takeUntil} from "rxjs/operators";
import {Personal, PersonalData} from "../../interfaces/personal-data";
import {NpCities, NpCity} from "../../interfaces/np-city";
import {RequestData} from "../../interfaces/request-data";
import {Currencies} from "../../interfaces/currencies";
import * as moment from "moment";
import {Organization} from "../../interfaces/organization";
import {OrganizationsService} from "../../services/organizations.service";
import {ModalOrganizationComponent} from "./modal-organization/modal-organization.component";
import {HttpErrorNotifyService} from "../../services/http-error-notify.service";

@Component({
  selector: 'app-personal',
  templateUrl: './personal.component.html',
  styleUrls: ['./personal.component.scss']
})
export class PersonalComponent extends BaseService implements OnDestroy, OnInit {
  @ViewChild('phoneRef') phoneRef: ElementRef<HTMLInputElement>;
  @ViewChild(ModalOrganizationComponent) modalOrganizationComponentRef: ModalOrganizationComponent;

  public isDestroyed: Subject<boolean> = new Subject();
  public data: Personal;
  public currencies: Currencies[];
  private timeoutSearch: ReturnType<typeof setTimeout>;
  public addressData = [];
  public wrongFio: boolean = false;
  public wrongPhone: boolean = false;
  public wrongCity: boolean;
  public password: string = '';
  public newPassword: string = '';
  public newPassword2: string = '';
  public wrongPassword: string = '';
  public wrongPassword2: string = '';
  public wrongNewPassword: string = '';
  public wrongEmail: boolean = false;
  public successfullySaved: boolean = false;
  // Друга відправка зміни пароля (Enter по кнопці у фокусі - лоадер ловить лише мишу) йшла зі старою
  // кукою password: бек відповідав not_authorized і викидав клієнта на /login або «Невірний поточний пароль»
  public isChangingPassword: boolean = false;
  public isModalInstructionsShow: boolean = false;
  public isPasswordShow: boolean = false;
  currentYear: number;
  public organizations: Organization[] = [];
  public buEnabled: boolean = true;
  public buStuck: boolean = false;
  public newOrganization: Organization = {
    name: '',
    type: 'fop',
    edrpou: '',
    error: false,
    errorMessage: '',
  };
  public organizationError: string = '';

  constructor(
    private http: HttpClient,
    private titleService: Title,
    private meta: Meta,
    private organizationsService: OrganizationsService,
    private notify: HttpErrorNotifyService,
  ) {
    super();

    const title = 'Маслоточка | Налаштування облікового запису';
    this.titleService.setTitle(title);
    this.currentYear = moment().year();
    this.meta.addTag({name: 'title', content: title});
    this.meta.addTag({name: 'og:title', content: title});
    this.meta.addTag({name: 'twitter:title', content: title});
    this.meta.addTag({name: 'DC.title', content: title});
  }

  ngOnInit() {
    this.getData();

    this.organizationsService.organizations$
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((organizations: Organization[]) => {
        this.organizations = organizations;
        this.buEnabled = this.organizationsService.buEnabled;
        // При вимкненому «білому обліку» блок організацій лишаємо тим, у кого активна ФОП/ТОВ, -
        // щоб могли повернутися на «Фіз особа» (оформлення по БУ бек відхиляє), картка #628
        this.buStuck = !this.buEnabled && organizations.some((org) => (org.is_active === '1' || org.is_active === true) && org.type !== 'fiz');
      });
  }

  getData() {
    this.http.get(this.apiRoot + 'personal/data')
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: PersonalData) => {
        this.data = data.data;
        this.currencies = Object.values(data.data.currencies);
        this.data.areas = Object.values(data.data.areas);

        this.data.no_email_notify_arrival_zgoods = !this.data.no_email_notify_arrival_zgoods;
        this.data.no_email_notify_made_order = !this.data.no_email_notify_made_order;
        this.data.no_email_notify_order_changed = !this.data.no_email_notify_order_changed;
        this.data.no_email_notify_order_date_changed = !this.data.no_email_notify_order_date_changed;
        this.data.no_email_notify_order_from_admin = !this.data.no_email_notify_order_from_admin;
        this.data.no_window_notify_arrival_favorites = !this.data.no_window_notify_arrival_favorites;
        this.data.no_window_notify_arrival_zgoods = !this.data.no_window_notify_arrival_zgoods;
        this.data.no_window_notify_order_changed = !this.data.no_window_notify_order_changed;
        this.data.no_window_notify_order_date_changed = !this.data.no_window_notify_order_date_changed;
        this.data.no_window_notify_order_from_admin = !this.data.no_window_notify_order_from_admin;
        this.data.no_telega_notify_arrival_favorites = !this.data.no_telega_notify_arrival_favorites;
        this.data.no_telega_notify_arrival_zgoods = !this.data.no_telega_notify_arrival_zgoods;
        this.data.no_telega_notify_order_changed = !this.data.no_telega_notify_order_changed;
        this.data.no_telega_notify_order_date_changed = !this.data.no_telega_notify_order_date_changed;
        this.data.no_notify_order_date_changed = !this.data.no_notify_order_date_changed;
        this.data.no_telega_notify_order_driver = !this.data.no_telega_notify_order_driver;
        this.data.no_telega_notify_order_ttn = !this.data.no_telega_notify_order_ttn;
        this.data.no_telega_notify_order_goodsarrive = !this.data.no_telega_notify_order_goodsarrive;
        this.data.no_telega_notify_payment = !this.data.no_telega_notify_payment;
        this.data.no_telega_notify_change_currencyrate = !this.data.no_telega_notify_change_currencyrate;
        this.data.no_telega_notify_change_statusorder = !this.data.no_telega_notify_change_statusorder;
        this.data.no_telega_notify_return_requests = !this.data.no_telega_notify_return_requests;
        this.data.no_telega_notify_places_for_dropship = !this.data.no_telega_notify_places_for_dropship;
        this.data.no_telega_notify_pay_delivery = !this.data.no_telega_notify_pay_delivery;
        this.data.no_telega_notify_goods_change_warehouse = !this.data.no_telega_notify_goods_change_warehouse;
        this.data.no_telega_notify_nova_poshta_arrived = !this.data.no_telega_notify_nova_poshta_arrived;
      });
  }

  createOrganization(organization: Organization) {

    if (organization.error) {
      // модалка ждёт ответа (isSaving) — отпускаем кнопку, иначе она останется заблокированной
      this.modalOrganizationComponentRef.saveFailed(organization.errorMessage || '');

      return;
    }

    organization.name = organization.name.trim();

    this.organizationsService.createOrganization({
      name: organization.name,
      type: organization.type,
      edrpou: organization.edrpou,
    } as Organization)
      .pipe(takeUntil(this.isDestroyed))
      .subscribe({
        next: (data: RequestData) => {
          // #358: бэк проверяет код по форме власності (ТОВ 8 / ФОП 10 цифр) и отвечает готовым
          // текстом в error — показываем его в модалке, она остаётся открытой с введёнными данными
          if (data && data.error) {
            this.modalOrganizationComponentRef.saveFailed(data.error);

            return;
          }

          this.modalOrganizationComponentRef.closeModal();
          this.organizationsService.getOrganizations();
        },
        error: () => {
          // HTTP-ошибку (500, нет связи) интерцептор уже показал тостом; тут только отпускаем кнопку
          this.modalOrganizationComponentRef.saveFailed('Не вдалося зберегти організацію. Спробуйте ще раз.');
        },
        complete: () => {
          // Завершение без ответа - запрос отменён кнопкой «Скасувати» лоадера: «Зберегти» оставалась
          // заблокированной (isSaving). Бэк мог уже создать организацию - перечитываем список
          if (this.modalOrganizationComponentRef.isSaving) {
            this.modalOrganizationComponentRef.saveFailed('Збереження скасовано. Організація могла вже зберегтися - перевірте список перед повторною спробою.');
            this.organizationsService.getOrganizations();
          }
        },
      });
  }

  deleteOrganization(organization: Organization) {
    this.organizationError = '';

    this.organizationsService.deleteOrganization(organization.id)
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: RequestData) => {
        if (data && data.error) {
          this.organizationError = data.error;

          return;
        }

        this.organizationsService.getOrganizations();
      });
  }

  setActiveOrganization(organization: Organization) {

    if (!organization.id) {
      return;
    }

    this.organizationsService.setActiveOrganization(organization.id)
      .pipe(takeUntil(this.isDestroyed))
      .subscribe(() => {
        this.organizationsService.getOrganizations();
      });
  }

  addOrganization() {
    this.newOrganization = {
      name: '',
      type: 'fop',
      edrpou: '',
      error: false,
      errorMessage: '',
    };

    this.modalOrganizationComponentRef.modalShow();
  }

  searchCity() {
    clearTimeout(this.timeoutSearch);

    // Текст міста змінено вручну - старий city_id/area_id НП більше не відповідає назві,
    // скидаємо і вимагаємо вибір зі списку (getCity); бек без city_id поверне 'empty city'
    this.data.city_id = '';
    this.data.area_id = null;

    if (!this.data.city || this.data.city.length < 3) {
      this.addressData = [];
      return;
    }

    this.timeoutSearch = setTimeout(() => {
      this.getNpCities(this.data.city)
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: NpCities) => {
          this.addressData = data && Array.isArray(data.data) ? data.data : [];
        })
    }, 500);
  }

  getNpCities(search: string) {
    return this.http.post(this.apiRoot + 'geo/search_cities', {
      search: search,
    })
  }

  getCity(i) {
    const city: NpCity = this.addressData[i];

    this.data.city = city.description;
    this.data.city_id = city.ref;
    this.data.area_id = city.area_id;
    this.addressData = [];
    this.wrongCity = false;
  }

  saveInfo() {
    let isValidSurveyForm = false;

    if (!/^[A-Za-zА-Яа-яІЇіїЄєҐґ.,\-+='’ʼ‘"“”«»„\d:() ]{3,60}$/.test(this.data.fio)) {
      this.wrongFio = true;
      isValidSurveyForm = true;
    } else {
      this.wrongFio = false;
    }

    const phone = this.phoneRef.nativeElement.value
      .replace(/\+38/g, '')
      .replace(/\D/g, '');

    if (!/^\d{10}$/.test(phone)) {
      this.wrongPhone = true;
      isValidSurveyForm = true;
    } else {
      this.wrongPhone = false;
    }

    if (!this.data.city || !this.data.city_id || !this.data.area_id) {
      this.wrongCity = true;
      isValidSurveyForm = true;
    } else {
      this.wrongCity = false;
    }

    if (!isValidSurveyForm) {
      this.http.post(this.apiRoot + 'personal/save_info', {
        fio: this.data.fio,
        phone: '+' + this.phoneRef.nativeElement.value.replace(/\D/g, ''),
        city_id: this.data.city_id,
        area_id: this.data.area_id,
        city: this.data.city,
      })
        .pipe(takeUntil(this.isDestroyed))
        .subscribe((data: RequestData) => {
          if (data.error === 'empty fio') {
            this.wrongFio = true;
          } else if (data.error === 'wrong phone') {
            this.wrongPhone = true;
          } else if (data.error === 'empty city') {
            this.wrongCity = true;
            this.data.city = '';
          } else if (data.data === 'success') {
            this.getData();
          } else if (data.error && data.error.startsWith('Змінити ПІБ, телефон та місто може лише адміністратор')) {
            // бек (can_edit_info) відмовив - раніше збереження мовчки нічого не робило
            this.notify.show('Дані не збережено', 'Змінити ПІБ, телефон і місто може лише адміністратор. Зверніться до свого менеджера.');
          } else if (data.error) {
            this.notify.show('Дані не збережено', 'Спробуйте ще раз. Якщо помилка повториться - зверніться до менеджера.');
          }
        });
    }
  }

  clickShowPassword() {
    this.isPasswordShow = true;
  }

  clickHidePassword() {
    this.isPasswordShow = false;
  }

  saveNewPassword() {
    let isValidRegisterForm: boolean = false;

    if (this.password.length < 3) {
      this.wrongPassword = 'Веедіть пароль';
      isValidRegisterForm = true;
    } else {
      this.wrongPassword = '';
    }

    // Минимум 7, как у бэка (c_personal change_password, auth/restore_confirm) — решение по #523
    if (this.newPassword.length < 7) {
      this.wrongNewPassword = 'Мінімальний пароль 7 символів';
      isValidRegisterForm = true;
    } else {
      this.wrongNewPassword = '';
    }

    // Дефис экранирован: раньше `\.-/` читался как диапазон от точки до слэша,
    // и пароль с дефисом отклонялся, хотя подсказка и бэк (c_personal change_password) его допускают
    // «Ґґ» разрешены и на бэке (#523); /u — длина в символах, как в регулярке бэка
    // wrongNewPassword у шаблоні не виводиться - помилки показуємо під повтором, як і відповідь бека 'short'.
    // Інакше на короткий пароль клієнт бачив лише «Допустимі символи», хоча всі символи допустимі.
    if (this.wrongNewPassword) {
      this.wrongPassword2 = this.wrongNewPassword;
    } else if (!/^[A-Za-zА-Яа-яІЇіїЄєҐґ'+.\-/\d]{7,30}$/u.test(this.newPassword)) {
      this.wrongPassword2 = 'Допустимі символи: (+), (.), (-)';
      isValidRegisterForm = true;
    } else if (this.newPassword2 != this.newPassword) {
      this.wrongPassword2 = 'Навірно введений повторний пароль';
      isValidRegisterForm = true;
    } else {
      this.wrongPassword2 = '';
    }

    if (!isValidRegisterForm) {
      if (this.isChangingPassword) {
        return;
      }

      this.isChangingPassword = true;

      this.http.post(this.apiRoot + 'personal/change_password', {
        password: this.password,
        new_password: this.newPassword,
        new_password2: this.newPassword2,
      })
        .pipe(
          takeUntil(this.isDestroyed),
          finalize(() => this.isChangingPassword = false)
        )
        .subscribe((data: RequestData) => {
          if (data.error === 'wrong password') {
            this.wrongPassword = 'Невірний поточний пароль';
          } else if (data.error === 'empty password') {
            this.wrongPassword2 = 'Мінімальний пароль 7 символів';
          } else if (data.error === 'wrong new password') {
            this.wrongPassword2 = 'Навірно введений повторний пароль';
          } else if (data.error === 'wrong password format') {
            this.wrongPassword2 = 'Допустимі символи: (+), (.), (-)';
          } else if (data.data === 'success') {
            this.successfullySaved = true;

            setTimeout(() => {
              this.successfullySaved = false;
              this.password = '';
              this.newPassword = '';
              this.newPassword2 = '';

              this.getData();
            }, 3000);
          }
        });
    }
  }

  sendPriceToEmailCheckbox() {
    this.data.price_our = !this.data.price_our;
  }

  priceContainsExpectedPositionCheckbox() {
    this.data.price_not_available = !this.data.price_not_available;
  }

  partnerPriceCheckbox(category: string) {
    this.data[category] = !this.data[category];
  }

  priceAllArticlesCheckbox() {
    this.data.price_all_articles = !this.data.price_all_articles;
  }

  sendPricePartners() {
    let price_partner_oils: number;
    if (this.data.price_partner_oils === true) {
      price_partner_oils = 1;
    } else {
      price_partner_oils = 0;
    }

    let price_partner_filters: number;
    if (this.data.price_partner_filters === true) {
      price_partner_filters = 1;
    } else {
      price_partner_filters = 0;
    }

    let price_partner_parts: number;
    if (this.data.price_partner_parts === true) {
      price_partner_parts = 1;
    } else {
      price_partner_parts = 0;
    }

    let price_our: number;
    if (this.data.price_our === true) {
      price_our = 1;
    } else {
      price_our = 0;
    }

    this.http.post(this.apiRoot + 'personal/send_price', {
      price_our: price_our,
      price_currency_id: this.data.price_currency_id,
      email_for_price: this.data.email_for_price,
      price_not_available: this.data.price_not_available,
      price_partner_oils: price_partner_oils,
      price_partner_filters: price_partner_filters,
      price_partner_parts: price_partner_parts,
      price_all_articles: this.data.price_all_articles,
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: RequestData) => {
        this.wrongEmail = data.error.length > 0;

        if (data.data === 'success') {
          this.successfullySaved = true;

          setTimeout(() => {
            this.successfullySaved = false;

            this.getData();
          }, 3000);
        }
      });
  }

  saveEmailSettings() {
    this.http.post(this.apiRoot + 'personal/save_email_settings', {
      no_email_notify_arrival_zgoods: !this.data.no_email_notify_arrival_zgoods,
      no_email_notify_made_order: !this.data.no_email_notify_made_order,
      no_email_notify_order_changed: !this.data.no_email_notify_order_changed,
      no_email_notify_order_date_changed: !this.data.no_email_notify_order_date_changed,
      no_email_notify_order_from_admin: !this.data.no_email_notify_order_from_admin,
      no_window_notify_arrival_favorites: !this.data.no_window_notify_arrival_favorites,
      no_window_notify_arrival_zgoods: !this.data.no_window_notify_arrival_zgoods,
      no_window_notify_order_changed: !this.data.no_window_notify_order_changed,
      no_window_notify_order_date_changed: !this.data.no_window_notify_order_date_changed,
      no_window_notify_order_from_admin: !this.data.no_window_notify_order_from_admin,
      no_telega_notify_arrival_favorites: !this.data.no_telega_notify_arrival_favorites,
      no_telega_notify_arrival_zgoods: !this.data.no_telega_notify_arrival_zgoods,
      no_telega_notify_order_changed: !this.data.no_telega_notify_order_changed,
      no_telega_notify_order_date_changed: !this.data.no_telega_notify_order_date_changed,
      no_notify_order_date_changed: !this.data.no_notify_order_date_changed,
      no_telega_notify_order_driver: !this.data.no_telega_notify_order_driver,
      no_telega_notify_order_ttn: !this.data.no_telega_notify_order_ttn,
      no_telega_notify_order_goodsarrive: !this.data.no_telega_notify_order_goodsarrive,
      no_telega_notify_payment: !this.data.no_telega_notify_payment,
      no_telega_notify_change_currencyrate: !this.data.no_telega_notify_change_currencyrate,
      no_telega_notify_change_statusorder: !this.data.no_telega_notify_change_statusorder,
      no_telega_notify_return_requests: !this.data.no_telega_notify_return_requests,
      no_telega_notify_places_for_dropship: !this.data.no_telega_notify_places_for_dropship,
      no_telega_notify_pay_delivery: !this.data.no_telega_notify_pay_delivery,
      no_telega_notify_goods_change_warehouse: !this.data.no_telega_notify_goods_change_warehouse,
      no_telega_notify_nova_poshta_arrived: !this.data.no_telega_notify_nova_poshta_arrived,
    })
      .pipe(takeUntil(this.isDestroyed))
      .subscribe((data: RequestData) => {
        if (data.data === 'success') {
          this.successfullySaved = true;

          setTimeout(() => {
            this.successfullySaved = false;

            this.getData();
          }, 3000);
        }
      });
  }

  switchCheckbox(name) {
    this.data[name] = !this.data[name];
  }

  showInstructions() {
    this.isModalInstructionsShow = true;
  }

  closeModal() {
    this.isModalInstructionsShow = false;
  }

  ngOnDestroy() {
    this.isDestroyed.next(true);
    this.isDestroyed.complete();
  }
}
